import { render, staticRenderFns } from "./NewsTicker.vue?vue&type=template&id=ab25b7d8&"
import script from "./NewsTicker.vue?vue&type=script&lang=ts&"
export * from "./NewsTicker.vue?vue&type=script&lang=ts&"
import style0 from "./NewsTicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports